import { LoginPage, MapPage } from '../pages';
import { Auth } from 'aws-amplify';

const publicRoutes = [
    {
        link: '/login',
        component: <LoginPage />,
        isMainPage: true,
    },
];
const privateRoutes = [
    {
        link: '/map',
        component: <MapPage />,
        isMainPage: true,
    },
];
const routes = {
    public: publicRoutes,
    private: privateRoutes,
};
export const hasRoute = (route = window.location.pathname) => {
    if (route === '/') return true;
    const allRoutes = [ ...publicRoutes, ...privateRoutes ];
    return allRoutes.some(({ link }) => link === route);
};
export const getRoutes = async () => {
    let availableRoutes = [];
    try {
        await Auth.currentAuthenticatedUser();
        availableRoutes = routes.private;
    } catch (err) {
        availableRoutes = routes.public;
    }
    const { link: mainPageLink } = availableRoutes.find(({ isMainPage }) => isMainPage);
    return {
        availableRoutes,
        mainPageLink,
    };
};
